import React, { useState } from 'react';
import { View } from 'react-native-web';
import { Image, TouchableOpacity } from 'react-native';
import { LocStr } from '../utils/Utils';
import {
  available_languages_list,
  available_languages_str,
  configure_which_languages_str,
  engineType,
  keyboard_language_str,
  language_engine_str,
  paykey_engine,
  paykey_nlp,
  rebit,
  rebit_engine,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import OpenBoxPanel from '../components/PanelsComponents/Buttons/OpenBoxPanel';
import SwitcherPanelList from '../components/PanelsComponents/Buttons/SwitcherPanelList';
import RegularText from '../components/PanelsComponents/Text/RegularText';
import { img_dropdown } from '../utils/ImagesManagementUtils';
import AvailableLanguagesList from '../components/PanelsComponents/Buttons/AvailableLanguagesList';

//= ========================================================================

const Panel_Y01_keyboardLanguage = ({
  onStepPressed,
  onConfigChanged,
  globJSON,
  selectedScreen,
  language,
}) => {
  const { keyboard_language } = globJSON.configurations.keyboard;
  const all_languages = keyboard_language.is_rebit_engine
    ? keyboard_language.available_languages.rebit_engine : keyboard_language.available_languages.paykey_engine;
  const engine_type = keyboard_language.is_rebit_engine ? rebit_engine : paykey_engine;
  const available_languages_by_engine = keyboard_language.available_languages[engine_type];
  const [isEngineBoxOpen, setEngineBoxOpen] = useState(false);
  const [isLanguagesBoxOpen, setLanguagesBoxOpen] = useState(false);
  const countLanguageText = Object.keys(available_languages_by_engine)
    .filter((item) => available_languages_by_engine[item].available)
    .map((languageKey, index) => (index === 0 ? available_languages_list[languageKey] : `${index + 1} selected`));

  const availableLanguagesByEngine = Object.keys(all_languages)
    .filter((language_keys) => all_languages[language_keys].available)
    .map((language_key) => (language_key));
  const myStyles = {
    container: {
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: 5,
      paddingStart: 20,
      paddingEnd: 20,
    },
    TouchableOpacityContainer: {
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
      backgroundColor: isLanguagesBoxOpen ? '#f7fafc' : '#ffffff',
      paddingStart: 12,
      width: 170,
      height: 36,
      borderRadius: 4,
      border: 'solid 1px #cbd5e0',
    },
    imageStyle: {
      width: 24,
      height: 24,
    },
    switcherPanelStyleComponent: {
      padding: 8,
      borderWidth: 1,
      borderRadius: 4,
      border: 'solid 1px #CBD5E0',
    },
  };

  return (
    <FullPagePanel
      globJSON={globJSON}
      selectedScreen={selectedScreen}
      onConfigChanged={onConfigChanged}
      onStepPressed={onStepPressed}
      panelHeadline={keyboard_language_str}
      paragraph={configure_which_languages_str}
      tooltipsTitles={globJSON.configurations.keyboard.screens_ordering}
      disableEditElements
      language={language}
      paddingVertical={25}
    >
      <View style={{ zIndex: 2 }}>
        <OpenBoxPanel
          cleanBackground
          language={language}
          isBoxOpen={isEngineBoxOpen}
          text={LocStr(language_engine_str, language)}
          chosenValue={keyboard_language.is_rebit_engine ? rebit : paykey_nlp}
          valuesMap={engineType}
          onPress={() => {
            setEngineBoxOpen(!isEngineBoxOpen);
          }}
          onValueChanged={(valueId) => {
            keyboard_language.is_rebit_engine = valueId === rebit;
            onConfigChanged();
          }}
          marginBottom={10}
        />
      </View>

      <View style={myStyles.container}>
        <RegularText marginBottom={0}>{available_languages_str}</RegularText>
        <TouchableOpacity
          style={myStyles.TouchableOpacityContainer}
          onPress={() => {
            setLanguagesBoxOpen(!isLanguagesBoxOpen);
          }}
        >
          <RegularText marginBottom={0}>{countLanguageText[countLanguageText.length - 1]}</RegularText>
          <Image
            style={myStyles.imageStyle}
            source={img_dropdown}
          />
        </TouchableOpacity>
      </View>

      {isLanguagesBoxOpen
            && (
            <View style={myStyles.switcherPanelStyleComponent}>
              <SwitcherPanelList
                ArgumentList={all_languages}
                onConfigChanged={onConfigChanged}
                setLanguagesBoxOpen={setLanguagesBoxOpen}
                isLanguagesBoxOpen={isLanguagesBoxOpen}
                onPress={() => {
                  setLanguagesBoxOpen(!isLanguagesBoxOpen);
                }}
                default_language={keyboard_language.default_languages[engine_type]}
              />
            </View>
            )}

      {!isLanguagesBoxOpen && availableLanguagesByEngine.length > 1
            && (
            <AvailableLanguagesList
              ArgumentList={availableLanguagesByEngine}
              onConfigChanged={onConfigChanged}
              keyboard_language={keyboard_language}
              language={language}
            />
            )}

    </FullPagePanel>
  );
};

export default Panel_Y01_keyboardLanguage;
